module.exports = __webpack_public_path__ + "img/Size-Matters-Most-Of-The-Time.bbfe971f.jpg";